












import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';

interface Data {}

interface Methods {
  outsideClick: (e: Event) => void;
}

interface Computed {}

interface Props {
  close: () => void | null;
}

export default Vue.extend({
  name: 'ServiceModal',
  props: {
    close: null,
  },
  methods: {
    outsideClick(e: MouseEvent) {
      if (!this.$refs.modal || (this.$refs.modal as HTMLElement).contains(e.target as HTMLElement)) {
        return;
      }
      this.close();
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.outsideClick);
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.outsideClick);
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
